import { render } from "./ChanelConfig.vue?vue&type=template&id=15ee0880&scoped=true"
import script from "./ChanelConfig.vue?vue&type=script&lang=js"
export * from "./ChanelConfig.vue?vue&type=script&lang=js"

import "./ChanelConfig.vue?vue&type=style&index=0&id=15ee0880&scoped=true&lang=css"

import exportComponent from "/Users/yunlian/Documents/ccar.fun/purepay/new-pay3-cs-frontweb/new-pay3-cs-frontweb2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ee0880"]])

export default __exports__